<template>
  <div class="row">
    <div class="col-lg-12">
      <h1 class="page-header">Vereadores</h1>
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <list
            ref="vuetable"
            :show-empty="true"
            title="Lista de vereadores"
            report-title="Vereadores"
            :initial-page="pagina"
            api-url="vereador"
            :fields="fields"
            :pageCollection="'vereadores'"
            :append-params="filtros"
          >
            <template slot="filters">
              <div class="collapse" id="filtros">
                <div class="col-sm-4">
                  <label class="primary" for="nome_filter">Nome</label>
                  <input
                    type="text"
                    v-model="nome"
                    class="form-control"
                    name="nome_filter"
                  />
                </div>
                <div class="col-xs-12">
                  <button
                    @click="consultar()"
                    class="btn btn-default margem-topo"
                    name="btnFiltrar"
                  >
                    <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                    Filtrar
                  </button>
                  <button
                    @click="limpar()"
                    class="btn btn-default margem-topo"
                    name="btnLimpar"
                  >
                    <font-awesome-icon :icon="'eraser'"></font-awesome-icon>
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </template>
            <template slot="actions">
              <router-link
                :to="{ name: 'user_salvar_vereador' }"
                class="btn btn-default"
              >
                <font-awesome-icon :icon="'plus'"></font-awesome-icon>
                Adicionar
              </router-link>
              <button
                class="btn btn-default"
                data-toggle="collapse"
                data-target="#filtros"
              >
                <font-awesome-icon :icon="'filter'"></font-awesome-icon> Filtros
              </button>
            </template>
            <template slot="rowrender" slot-scope="props">
              <button
                title="Editar"
                type="button"
                class="btn btn-primary"
                @click="editar(props.rowData)"
              >
                <font-awesome-icon :icon="'edit'"></font-awesome-icon>
              </button>
              <button
                title="Excluir"
                class="btn btn-danger"
                @click="excluir(props.rowData)"
              >
                <font-awesome-icon :icon="'trash'"></font-awesome-icon>
              </button>
            </template>
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import list from '@/components/common/DataTable'
import { request } from '@/request'
import modal from '@/components/common/Modal'

export default {
  name: 'vereadores',
  inject: ["showConfirm"],
  data() {
    return {
      fields: [
        {
          name: 'nome',
          title: 'Nome',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-2',
          dataClass: 'text-center'
        }
      ]
    }
  },
  components: {
    list,
    modal
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  computed: {
    filtros() {
      const { nome } = this

      return {
        nome
      }
    },
    pagina: {
      get() {
        const { vereadores } = this.$store.state.vuetableState
        const { pagina } = vereadores
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'vereadores',
          value: value
        })
      }
    },
    nome: {
      get() {
        const { vereadores } = this.$store.state.vuetableState
        const { nome } = vereadores.filtros
        return nome
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'nome',
          collection: 'vereadores',
          value: value
        })
        this.resetPageStore()
      }
    }
  },
  methods: {
    editar(data) {
      const { id } = data
      this.$router.push({
        name: 'user_salvar_vereador',
        params: { id }
      })
    },
    excluir(data) {
      const me = this
      const { id } = data

      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request
            .delete(`vereador/${id}`)
            .then(resp => {
              me.consultar()
              me.$toastr.s('Vereador removido com sucesso!')
            })
            .catch(error => {
              me.$toastr.e(
                'Houve uma falha ao tentar remover esse item, por favor, tente novamente mais tarde!'
              )
            })
        }
      }

      this.showConfirm(
        'Deseja realmente deletar este item?',
        config
      )
    },
    consultar() {
      this.$nextTick(function() {
        this.$refs.vuetable.refresh()
      })
    },
    limpar() {
      this.nome = ''
      this.$nextTick(function() {
        this.$refs.vuetable.refresh()
      })
    },
    resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'vereadores',
        value: 1
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/emendas-parlamentares/vereadores/index.vue